import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
import { desaturate, lighten, tint } from "polished";
var getPrimaryStyles = function(defaultColor, highlightColor, theme) {
    return /*#__PURE__*/ css("color:", theme.color.natural0, ";background-color:", defaultColor, ";transition:background 1s;&:hover,&:focus-visible{background-color:", highlightColor, ";background-image:radial-gradient(\n      circle,transparent 1%,", highlightColor, " 1%\n    );background-position:center;background-size:15000%;}&:active{background-color:", tint(0.15, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getSecondaryStyles = function(defaultColor, highlightColor, isSmallButton, theme) {
    return /*#__PURE__*/ css("padding:", isSmallButton ? "0.5rem 0.75rem" : "0.875rem 1.875rem", ";border:2px solid currentcolor;color:", defaultColor, ";background-color:", theme.color.natural0, ";transition-property:color,background,border-color;transition-duration:1s;&:hover,&:focus-visible{color:", highlightColor, ";background-color:", theme.color.natural0, ";background-image:radial-gradient(\n      circle,transparent 1%,", theme.color.natural0, " 1%\n    );background-position:center;background-size:15000%;}&:active{color:", highlightColor, ";background-color:", tint(0.8, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getBasicStyles = function(isCentered, isSmallButton, theme) {
    return /*#__PURE__*/ css("display:block;margin:", theme.spacing[50], " ", isCentered ? "auto" : "0", " 0;padding:", isSmallButton ? "0.625rem 1rem" : "1rem 2rem", ";border:0;outline:0;border-radius:0.5rem;box-sizing:border-box;max-width:fit-content;white-space:nowrap;text-decoration:none;fill:currentcolor;background-position:center;");
};
var getVariantSpecificStyles = function(isSecondaryButton, isSmallButton, theme) {
    var defaultColor = theme.color.primary;
    var highlightColor = lighten(0.3, desaturate(0.6, defaultColor));
    if (isSecondaryButton) {
        return getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme);
    }
    return getPrimaryStyles(defaultColor, highlightColor, theme);
};
var StyledAnchor = /*#__PURE__*/ styled("a", {
    target: "e1po54mf0"
})(function(param) {
    var theme = param.theme, isCentered = param.isCentered, isSmallButton = param.isSmallButton;
    return getBasicStyles(isCentered, isSmallButton, theme);
}, " ", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton;
    return getVariantSpecificStyles(isSecondaryButton, isSmallButton, theme);
}, ";");
var StyledMaskedLink = /*#__PURE__*/ styled(Ui.MaskedLink, {
    target: "e1po54mf1"
})(function(param) {
    var theme = param.theme, isCentered = param.isCentered, isSmallButton = param.isSmallButton;
    return getBasicStyles(isCentered, isSmallButton, theme);
}, " ", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton;
    return getVariantSpecificStyles(isSecondaryButton, isSmallButton, theme);
}, ";");
export { StyledAnchor, StyledMaskedLink };
